import React from "react";
import { Button } from "../../components/ui/Button";
import { useLocation, useNavigate } from "react-router-dom";
import FailIconDisplay from "src/components/ui/FailIconDisplay";
import { useTranslation } from "react-i18next";

const Fail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { page } = location?.state;
    const { t } = useTranslation();
    return (
        <div className="custom-container">
            <div className="flex justify-between flex-col items-center h-full pt-[10px]">
                <div className="pt-8">
                    <div>
                        <div className="text-h5 font-bold mb-2 text-flow-heading">{t('fail.title')}</div>
                        <div className="text-body text-Gray900">{t('fail.subtitle')}</div>
                    </div>
                    <div className="w-[313px] h-[313px]">
                        <div className="mt-4 relative">
                            <FailIconDisplay />
                        </div>
                    </div>
                    <div className="mt-2 px-3 py-3 text-center z-10">
                        <ul className="list-disc list-inside text-Gray900 mt-3">
                            <li>{t('fail.tip1')}</li>
                            <li>{t('fail.tip2')}</li>
                            <li>{t('fail.tip3')}</li>
                        </ul>
                    </div>
                    <div className="items-center px-4 py-3 bottom-0">
                        <Button onClick={() => navigate(page, { replace: true })} id="ok-btn" className="mt-1" variant="primaryWithoutIcon" >{t('fail.retry')}</Button>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default Fail
